import { defineStore } from 'pinia'
export default defineStore({
  id: 'connectDataTable',
  persist: true,
  state: () => {
    return {
      isConnectArchive: false

    }
  },
  actions: {
    setIsConnectArchive: function (payload: any) {
      this.isConnectArchive = payload
    }

  },
  getters: {
    getIsConnectArchive: (state: any) => state.isConnectArchive
  }
})
